export default "__VITE_ASSET__xrBKQTB8__"